/**
 * @packageDocumentation
 * @module Auth
 * @category Core
 */

/**
 * Действия для работы со стором профиля пользователя.
 *
 * @group Store Actions
 */
export namespace AuthProfileStateActions {
  /**
   * Загрузка профиля текущего пользователя.
   */
  export class Load {
    static readonly type = '[AuthProfile] Load';
  }

  /**
   * Инициализация прав доступа текущего пользователя.
   */
  export class InitPermissions {
    static readonly type = '[AuthProfile] InitPermissions';
  }
}
